import { useMemo } from 'react';

import Toolbar from '@lcsc-ui/components/ToolBar';
import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import ecpCurl from '@lcsc-ui/utils/ecpCurl';
import dayjs from 'dayjs';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import ListApi from '@/apis/list';
import OpApi from '@/apis/op';
import StaticdataApi from '@/apis/staticdata';
import ProductIndex from '@/features/ProductIndex';

const ProductIndexPage = (props) => {
  const { resourceData, websiteSectionList, catalogList, headerAd, renderSuccess, icDetail, releaseDate, pageUrl } =
    props;

  const metadata = useMemo(() => {
    return {
      title: `${icDetail?.icModel}中文资料_PDF数据手册_参数_引脚图_图片-立创商城`,
      additionalMetaTags: [
        {
          name: 'keywords',
          content: `${icDetail?.icModel}中文资料,${icDetail?.icModel}数据手册,${icDetail?.icModel}参数,${icDetail?.icModel}引脚图,${icDetail?.icModel}图片`,
        },
        {
          name: 'description',
          content: `立创商城提供${icDetail?.factoryModel}公司生产的${icDetail?.icModel}详细信息，包括中文资料、PDF数据手册、引脚图、商品实物图和购买链接等信息，采购${icDetail?.icModel}就上立创商城。`,
        },
      ],
    };
  }, [icDetail?.icModel]);

  return (
    <>
      <NextSeo
        title={metadata.title}
        additionalMetaTags={metadata.additionalMetaTags}
        noindex={icDetail?.icModel === undefined}
      />
      <Head>
        <link
          rel="canonical"
          href={
            icDetail?.icModel
              ? `${resourceData?.projectConfigVO?.lcscWwwUrl}/p/${icDetail?.icModel}_${icDetail?.icDataId}.html`
              : resourceData?.projectConfigVO?.lcscWwwUrl + pageUrl
          }
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:description"
          content={`${icDetail?.icModel}中文资料,${icDetail?.icModel}数据手册,${icDetail?.icModel}参数,${icDetail?.icModel}引脚图,${icDetail?.icModel}图片`}
        />
        <meta property="og:image" content={`${resourceData?.projectConfigVO?.lcscAttaUrl}${icDetail?.productImgUrl}`} />
        <meta property="og:release_date" content={releaseDate} />
        {renderSuccess && <meta name="lcscRender" content="true" />}
      </Head>
      <BaseLayout
        resourceData={resourceData}
        websiteSectionList={websiteSectionList}
        catalogList={catalogList}
        headerAd={headerAd}
        isLgScreen={false}
        notIndexHeaderAdapter
        onlySScreen
        isNeedTopAd={true}
        isShowBottomAd={true}
      >
        <ProductIndex {...props}></ProductIndex>
        <Toolbar></Toolbar>
      </BaseLayout>
    </>
  );
};

export default ProductIndexPage;

export async function getServerSideProps(context) {
  const slug = context?.params?.slug?.join('/')?.split('_');
  if (!slug) {
    return {
      notFound: true,
    };
  }
  const model = slug[0];
  const id = slug[1].replace('.html', '');
  const CouponsApiResults = await Promise.allSettled([
    ecpCurl(StaticdataApi.resourceList),
    ecpCurl(StaticdataApi.catalogList),
    ecpCurl(OpApi.websiteSection),
    ecpCurl(OpApi.advertisingHeader),
    ecpCurl(`${ListApi.icDetail}?icModel=${encodeURIComponent(model)}&id=${id}`),
    ecpCurl(`${ListApi.icRecommend}?currPage=1&pageSize=20&icDataId=${id}`),
  ]);
  const [resourceData, catalogList, websiteSectionList, headerAd, icDetail, icRecommend] = CouponsApiResults.map(
    (result) => {
      if (result.status === 'fulfilled') {
        return result.value;
      }
      return null;
    }
  );
  const renderSuccess = CouponsApiResults.every((result) => result.status === 'fulfilled');

  return {
    props: {
      resourceData,
      websiteSectionList,
      catalogList,
      headerAd,
      icDetail,
      icRecommend,
      renderSuccess,
      releaseDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      pageUrl: '/p/' + context?.params?.slug,
    },
  };
}
